/**
 * ISO 3166-1 alpha-2 options for admin selects (clinic address, filters).
 * value = uppercase code stored in API; label = English name + code for clarity.
 */
export const ISO_3166_ALPHA2_OPTIONS = [
  { value: "AD", label: "Andorra (AD)" },
  { value: "AE", label: "United Arab Emirates (AE)" },
  { value: "AL", label: "Albania (AL)" },
  { value: "AM", label: "Armenia (AM)" },
  { value: "AR", label: "Argentina (AR)" },
  { value: "AT", label: "Austria (AT)" },
  { value: "AU", label: "Australia (AU)" },
  { value: "BA", label: "Bosnia and Herzegovina (BA)" },
  { value: "BE", label: "Belgium (BE)" },
  { value: "BG", label: "Bulgaria (BG)" },
  { value: "BH", label: "Bahrain (BH)" },
  { value: "BR", label: "Brazil (BR)" },
  { value: "BY", label: "Belarus (BY)" },
  { value: "CA", label: "Canada (CA)" },
  { value: "CH", label: "Switzerland (CH)" },
  { value: "CL", label: "Chile (CL)" },
  { value: "CN", label: "China (CN)" },
  { value: "CO", label: "Colombia (CO)" },
  { value: "CY", label: "Cyprus (CY)" },
  { value: "CZ", label: "Czechia (CZ)" },
  { value: "DE", label: "Germany (DE)" },
  { value: "DK", label: "Denmark (DK)" },
  { value: "DZ", label: "Algeria (DZ)" },
  { value: "EE", label: "Estonia (EE)" },
  { value: "EG", label: "Egypt (EG)" },
  { value: "ES", label: "Spain (ES)" },
  { value: "FI", label: "Finland (FI)" },
  { value: "FR", label: "France (FR)" },
  { value: "GB", label: "United Kingdom (GB)" },
  { value: "GE", label: "Georgia (GE)" },
  { value: "GR", label: "Greece (GR)" },
  { value: "HR", label: "Croatia (HR)" },
  { value: "HU", label: "Hungary (HU)" },
  { value: "IE", label: "Ireland (IE)" },
  { value: "IL", label: "Israel (IL)" },
  { value: "IN", label: "India (IN)" },
  { value: "IQ", label: "Iraq (IQ)" },
  { value: "IR", label: "Iran (IR)" },
  { value: "IS", label: "Iceland (IS)" },
  { value: "IT", label: "Italy (IT)" },
  { value: "JO", label: "Jordan (JO)" },
  { value: "JP", label: "Japan (JP)" },
  { value: "KE", label: "Kenya (KE)" },
  { value: "KR", label: "South Korea (KR)" },
  { value: "KW", label: "Kuwait (KW)" },
  { value: "LB", label: "Lebanon (LB)" },
  { value: "LI", label: "Liechtenstein (LI)" },
  { value: "LT", label: "Lithuania (LT)" },
  { value: "LU", label: "Luxembourg (LU)" },
  { value: "LV", label: "Latvia (LV)" },
  { value: "LY", label: "Libya (LY)" },
  { value: "MA", label: "Morocco (MA)" },
  { value: "MC", label: "Monaco (MC)" },
  { value: "MD", label: "Moldova (MD)" },
  { value: "ME", label: "Montenegro (ME)" },
  { value: "MK", label: "North Macedonia (MK)" },
  { value: "MT", label: "Malta (MT)" },
  { value: "MX", label: "Mexico (MX)" },
  { value: "MY", label: "Malaysia (MY)" },
  { value: "NG", label: "Nigeria (NG)" },
  { value: "NL", label: "Netherlands (NL)" },
  { value: "NO", label: "Norway (NO)" },
  { value: "NZ", label: "New Zealand (NZ)" },
  { value: "OM", label: "Oman (OM)" },
  { value: "PL", label: "Poland (PL)" },
  { value: "PT", label: "Portugal (PT)" },
  { value: "QA", label: "Qatar (QA)" },
  { value: "RO", label: "Romania (RO)" },
  { value: "RS", label: "Serbia (RS)" },
  { value: "RU", label: "Russia (RU)" },
  { value: "SA", label: "Saudi Arabia (SA)" },
  { value: "SE", label: "Sweden (SE)" },
  { value: "SI", label: "Slovenia (SI)" },
  { value: "SK", label: "Slovakia (SK)" },
  { value: "SM", label: "San Marino (SM)" },
  { value: "TH", label: "Thailand (TH)" },
  { value: "TN", label: "Tunisia (TN)" },
  { value: "TR", label: "Türkiye (TR)" },
  { value: "TW", label: "Taiwan (TW)" },
  { value: "UA", label: "Ukraine (UA)" },
  { value: "US", label: "United States (US)" },
  { value: "VA", label: "Vatican City (VA)" },
  { value: "VN", label: "Vietnam (VN)" },
  { value: "ZA", label: "South Africa (ZA)" },
].sort((a, b) => a.label.localeCompare(b.label, "en"));

/**
 * @param {string} stored
 * @returns {{ value: string, label: string } | null}
 */
export function resolveIsoCountrySelectValue(stored) {
  const raw = stored != null ? String(stored).trim() : "";
  if (!raw) return null;
  const upper = raw.toUpperCase();
  const byCode = ISO_3166_ALPHA2_OPTIONS.find((o) => o.value === upper);
  if (byCode) return byCode;
  return { value: raw, label: raw };
}

/**
 * @param {string[]} legacyLabels free-text values already in DB
 * @returns {Array<{ value: string, label: string }>}
 */
export function mergeCountryFilterOptions(legacyLabels) {
  const base = [...ISO_3166_ALPHA2_OPTIONS];
  const seen = new Set(base.map((o) => o.value.toLowerCase()));
  (legacyLabels || []).forEach((lbl) => {
    const t = String(lbl || "").trim();
    if (!t) return;
    const key = t.toLowerCase();
    if (seen.has(key)) return;
    seen.add(key);
    base.push({ value: t, label: t });
  });
  return base.sort((a, b) => a.label.localeCompare(b.label, "en"));
}
